document.addEventListener('DOMContentLoaded', function () {
  // 1) Abaya size chart modal ko body ke end me move karo
  var sizeChartModal = document.getElementById('abayaSizeChartModal');
  if (sizeChartModal && sizeChartModal.parentNode !== document.body) {
    document.body.appendChild(sizeChartModal);
  }

  // 2) Custom size form toggle
  var customToggleBtn = document.querySelector('[data-abaya-custom-size-toggle]');
  var customForm = document.querySelector('[data-abaya-custom-size-form]');

  if (customToggleBtn && customForm) {
    customToggleBtn.addEventListener('click', function () {
      customForm.classList.toggle('is-open');
      if (customForm.classList.contains('is-open')) {
        customForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // 3) CUT buttons -> hidden input
  var cutButtons = document.querySelectorAll('[data-abaya-cut]');
  var cutInput = document.querySelector('[data-abaya-cut-input]');

  if (cutButtons.length && cutInput) {
    cutButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-abaya-cut');

        cutButtons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        cutInput.value = value;
      });
    });
  }
});






document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('sticky-header');
  if (!header) return;

  var logoWrapper = header.querySelector('.header__heading-logo-wrapper');
  if (!logoWrapper) return;

  // Logos URLs
  var homeLogoURL = 'https://cdn.shopify.com/s/files/1/0951/0522/0912/files/inti-logo.webp?v=1762296455';
  var homeWhiteLogoURL = 'https://cdn.shopify.com/s/files/1/0951/0522/0912/files/inti-logo-white.png?v=1764022227';
  var innerLogoURL = 'https://cdn.shopify.com/s/files/1/0951/0522/0912/files/inti-logo-white.png?v=1764022227';

  // Clear existing logos
  logoWrapper.innerHTML = '';

  var path = window.location.pathname;
  var viewportWidth = window.innerWidth;

  if (path === '/' || path === '/index.html') {
    // HOME page
    header.style.display = 'block';

    var img = document.createElement('img');
    img.alt = 'Home Logo';
    img.style.width = '90px';
    img.style.height = 'auto';

    if (viewportWidth <= 768) {
      // Mobile/tablet: white logo
      img.src = homeWhiteLogoURL;
    } else {
      // Desktop: normal logo
      img.src = homeLogoURL;
    }

    logoWrapper.appendChild(img);

  } else {
    // INNER pages
    header.style.display = 'block';

    var imgInner = document.createElement('img');
    imgInner.src = innerLogoURL;
    imgInner.alt = 'Inner Page Logo';
    imgInner.style.width = '90px';
    imgInner.style.height = 'auto';
    logoWrapper.appendChild(imgInner);
  }
});
